<template>
  <Layout style="height: 100%" class="main">
    <Sider hide-trigger collapsible :width="siderWidth" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con" v-on:click="toHome" style="cursor: pointer">
          <!-- <img v-show="!collapsed" :src="maxLogo" key="max-logo" />
              <img v-show="collapsed" :src="minLogo" key="min-logo" /> -->
          <span class="logo-icon"></span>
          <span v-show="!collapsed" class="logo-text">AUKEY</span>
        </div>
      </side-menu>
      <div class="left-sider-bg"></div>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :user-avator="userAvator" />
          <fullscreen v-model="isFullscreen" style="margin-right: 10px;" />
          <!-- <language v-if="$config.useI18n" @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local" /> -->
          <div class="tenaMobBtn" @click="tenaClick()">
            <span>+</span>
          </div>
          <div class="tenaDiv" v-if="tenashow">
            <TenantMuti style="margin-right: 30px;" v-on:reload="reload()" />
            <Tenant style="margin-right: 30px;" />
          </div>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <!--<div class="tag-nav-wrapper">-->
            <!--<tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag" />-->
          <!--</div>-->
          <Content class="content-wrapper" :style="{padding: $route.name === 'home' ? '0' : '10px'}">
            <keep-alive :include="cacheList">
              <router-view v-if="isRouterAlive"/>
            </keep-alive>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import Fullscreen from './components/fullscreen'
// import Language from './components/language'
import Tenant from './components/tenant'
import TenantMuti from './components/tenant-muti'
import ErrorStore from './components/error-store'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getNewTagList, getNextRoute, routeEqual } from '@/libs/util'
import minLogo from '@/assets/images/logo-min.jpg'
import maxLogo from '@/assets/images/logo.jpg'
import config from '@/config'
import './main.less'
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    // Language,
    TagsNav,
    Fullscreen,
    ErrorStore,
    User,
    Tenant,
    TenantMuti
  },
  data () {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
      siderWidth: 210,
      isFullscreen: false,
      screenWidth: document.body.clientWidth,
      isRouterAlive: true,
      tenashow: false
    }
  },
  computed: {
    ...mapGetters([
      'errorCount'
    ]),
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    userAvator () {
      return this.$store.state.user.avatorImgPath
    },
    cacheList () {
      return this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []
    },
    menuList () {
      return this.$store.getters.menuList
    },
    local () {
      return this.$store.state.app.local
    },
    hasReadErrorPage () {
      return this.$store.state.app.hasReadErrorPage
    }
  },
  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal'
    ]),
    ...mapActions([
      'handleLogin'
    ]),
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
      // 手机端设置左菜单关闭
      if (this.screenWidth < 768) {
        this.collapsed = true
      }
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type === 'all') {
        this.turnToPage('home')
      } else if (routeEqual(this.$route, route)) {
        if (type === 'others') {
        } else {
          const nextRoute = getNextRoute(this.tagNavList, route)
          this.$router.push(nextRoute)
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    },
    toHome () {
      this.$router.push({
        name: config.homeName
      })
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    tenaClick () {
      this.tenashow = !this.tenashow
    }
  },
  watch: {
    '$route' (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.addTag({
      route: this.$store.state.app.homeRoute
    })
    this.setBreadCrumb(this.$route)
    // 设置初始语言
    this.setLocal(this.$i18n.locale)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    // if (!this.tagNavList.find(item => item.name === this.$route.name)) {
    //   this.$router.push({
    //     name: this.$config.homeName
    //   })
    // }
    // 手机端设置
    if (this.screenWidth < 768) {
      this.collapsed = true
      this.siderWidth = 200
    } else {
      this.tenashow = true
    }
  }
}
</script>

<style lang="less">
  .left-sider .ivu-layout-sider-children::-webkit-scrollbar {
    display: none;
  }
  .tenaDiv{
    >*{
      display:inline-block;
    }
  }
  @media screen and (min-width:768px){
    .tenaMobBtn{
      display:none;
    }
    .tenantMuti{
      float:right;
    }
  }
  @media screen and (max-width:768px){
    .user-avator-dropdown{
      margin-right: 46px;
    }
    .tenaMobBtn{
      position: absolute;
      right: 13px;
      top: 18px;
      font-size:20px;
      width:26px;
      height:26px;
      line-height: 25px;
      border:1px solid #999;
      border-radius: 50%;
      text-align: center;
      color:#999;
      span{
        position:absolute;
        top: 0px;
        left: 6px;
        height:25px;
      }
    }
    .tenaDiv{
      padding: 0 20px;
      background:#fff;
      border-top: 1px solid #eee;
      position: fixed;
      top: 64px;
      width:100%;
      .tenantMuti{
        margin-right:0!important;
      }
    }
  }
</style>
